import { createModel } from "~~/package/utils/ModelUtil";
import Model from "~~/package/mapper/Model";
import type {
  ProSkillManagerSummarySlotModel
} from "~~/package/mapper/proSkillManager/model/summary/ProSkillManagerSummarySlotModel";

export class ProSkillManagerSummaryStatsModel extends Model {
  constructor(
    public average: number = 0,
    public slots: ProSkillManagerSummarySlotModel[] = []
  ) {
    super();
  }

  public static create(model: Partial<ProSkillManagerSummaryStatsModel>): ProSkillManagerSummaryStatsModel {
    return createModel<ProSkillManagerSummaryStatsModel>(ProSkillManagerSummaryStatsModel, {
      ...model
    });
  }
}
